<div class="reports-container">
  <div class="reports-topbar">
    <div class="topbar-left">
      <h1>
        Damaged Equipment
        <small>Assets in repair, maintenance, or written off</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        <a routerLink="/reports">IMS / Reports</a> /
        <span class="current">Damaged Equipment</span>
      </div>
    </div>
    <div class="topbar-right">
      <app-report-date-range />
      <a routerLink="/reports" class="btn btn-outline btn-sm">
        <i class="bi bi-arrow-left"></i> Back to Reports
      </a>
      <button class="btn btn-primary" (click)="exportData()"><i class="bi bi-download"></i> Export</button>
    </div>
  </div>

  <div class="report-period">
    <i class="bi bi-calendar3"></i>
    <span>Showing data for {{ dateRange.appliedLabel() }}</span>
  </div>

  <div class="report-card">
    <div class="report-header">
      <div class="report-title">
        <i class="bi bi-tools" style="color:#f59e0b;"></i>
        <h2>Damaged Equipment</h2>
        <span class="report-badge warning">{{ records().length }} items</span>
      </div>
    </div>
    <div class="report-body">
      <div class="damaged-list">
        @for (record of records(); track record.id) {
          <div class="damaged-item">
            <span class="damaged-asset">{{ record.equipment }}</span>
            <span class="damaged-status" [class]="statusClass(record.damageType, record.status)">
              {{ statusLabel(record.damageType, record.status) }}
            </span>
            <span class="asset-funeral">{{ record.reportNumber }} · {{ formatDate(record.reportedDate) }} · {{ formatCurrency(record.estimatedCost) }}</span>
          </div>
        } @empty {
          <p class="report-empty">No damaged equipment records for {{ dateRange.appliedLabel() }}.</p>
        }
      </div>
      <div class="report-footer">
        <span>{{ records().length }} damaged items for {{ dateRange.appliedLabel() }}</span>
      </div>
    </div>
  </div>
</div>
